import Alpine from "alpinejs";
import Cookies from 'js-cookie';
import {anchorLink} from "./alpine/anchorLink";
import {gallery} from "./alpine/gallery";
import {getIndexByHref, scrollToHref, scrollToIndex} from "./scroll";

Alpine.data('anchorLink', anchorLink);
Alpine.data('gallery', gallery);

Alpine.store('menu', {
    isOpen: false,
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
});

const cookieColorIndex = Cookies.get('bgColorIndex');
Alpine.store('colorChooser', {
    active: typeof cookieColorIndex !== 'undefined' ? Number(cookieColorIndex) : 1,
    classes: ['bg-bglight', 'bg-bgmiddle', 'bg-bgdark'],
    get activeClass() {
        return this.classes[this.active];
    },
    activate(i) {
        Cookies.set('bgColorIndex', i)
        this.active = i;
    },
});

Alpine.store('scroll', {
    active: 0,
    lastIndex: document.getElementsByClassName('contentPage').length - 1,
    get isFirst() {
        return this.active === 0;
    },
    get isLast() {
        return this.active === this.lastIndex;
    },
    setActive(i) {
        //console.log('set active', i);
        this.active = i;
    },
    goto(i) {
        i = Math.min(this.lastIndex, i);
        i = Math.max(0, i);
        this.setActive(i);
        scrollToIndex(i);
    },
    gotoNext() {
        this.goto(this.active + 1);
    },
    gotoPrev() {
        this.goto(this.active - 1);
    },
    gotoHref(href) {
        const i = getIndexByHref(href);
        this.setActive(i);
        scrollToHref(href);
    }
});

Alpine.start();
